var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import React, { useEffect, useRef, useState } from 'react';
import { OverlayPanel } from 'primereact/overlaypanel';
import { formatDate, getSocketUrl, useGetNotificationsQuery, useMarkNotificationReadMutation, } from '@igblsln/store';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { io } from 'socket.io-client';
import { useNotificationPopup } from '../NotificationPopup';
const notificationCardStyle = (isRead) => ({
    width: '100%',
    textAlign: 'left',
    border: '1px solid #e5e7eb',
    borderRadius: 8,
    padding: '0.75rem',
    background: isRead ? '#ffffff' : '#f5faff',
    cursor: 'pointer',
});
const getNotificationCategory = (notification) => {
    var _a, _b, _c, _d, _e, _f, _g;
    const backendCategoryLabel = (_a = notification.raw) === null || _a === void 0 ? void 0 : _a.category_label;
    if (backendCategoryLabel) {
        return backendCategoryLabel;
    }
    const backendCategory = (_b = notification.raw) === null || _b === void 0 ? void 0 : _b.category;
    if (backendCategory === 'ATTENDANCE_CHECK_IN' || backendCategory === 'ATTENDANCE_CHECK_OUT') {
        return 'Attendance';
    }
    const type = ((_c = notification.raw) === null || _c === void 0 ? void 0 : _c.notification_type) || ((_d = notification.raw) === null || _d === void 0 ? void 0 : _d.type);
    if (((_e = type === null || type === void 0 ? void 0 : type.startsWith) === null || _e === void 0 ? void 0 : _e.call(type, 'PR_')) || ((_f = notification.raw) === null || _f === void 0 ? void 0 : _f.pr_key) || notification.reference) {
        return 'Purchase Requisition';
    }
    if ((_g = type === null || type === void 0 ? void 0 : type.startsWith) === null || _g === void 0 ? void 0 : _g.call(type, 'ATTENDANCE_')) {
        return 'Attendance';
    }
    return 'Notifications';
};
const groupNotificationsByCategory = (items) => items.reduce((groups, item) => {
    const category = getNotificationCategory(item);
    groups[category] = groups[category] ? [...groups[category], item] : [item];
    return groups;
}, {});
const getRoute = (route, path, redirect_to, pr_key) => {
    if (route || path || redirect_to) {
        return (route || path || redirect_to || "").replace(/^#/, "");
    }
    if (pr_key) {
        return `/purchase/purchaserequisition/${pr_key}/edit`;
    }
    return "/purchase/purchaserequisition";
};
const getNotificationRoute = (notification) => {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j;
    return getRoute((_a = notification.route) !== null && _a !== void 0 ? _a : undefined, (_b = notification.raw) === null || _b === void 0 ? void 0 : _b.path, (_c = notification.raw) === null || _c === void 0 ? void 0 : _c.redirect_to, (_h = (_f = (_d = notification.reference) !== null && _d !== void 0 ? _d : (_e = notification.raw) === null || _e === void 0 ? void 0 : _e.pr_key) !== null && _f !== void 0 ? _f : (_g = notification.raw) === null || _g === void 0 ? void 0 : _g.pr_id) !== null && _h !== void 0 ? _h : (_j = notification.raw) === null || _j === void 0 ? void 0 : _j.entity_key);
};
const getSocketNotificationRoute = (payload) => {
    return getRoute(payload === null || payload === void 0 ? void 0 : payload.route, payload === null || payload === void 0 ? void 0 : payload.path, payload === null || payload === void 0 ? void 0 : payload.redirect_to, payload === null || payload === void 0 ? void 0 : payload.pr_key);
};
const isMatchingSocketAccount = (payload, clientId, companyId) => {
    if (!(payload === null || payload === void 0 ? void 0 : payload.client_id) || !(payload === null || payload === void 0 ? void 0 : payload.company_id)) {
        return true;
    }
    return String(payload.client_id) === String(clientId) && String(payload.company_id) === String(companyId);
};
const renderNotificationItem = (notification, onClick) => (React.createElement("button", { key: notification.id, type: "button", onClick: () => onClick(notification), style: notificationCardStyle(notification.read) },
    React.createElement("div", { style: { color: '#4b5563', fontSize: 13 } }, notification.message || 'Purchase requisition updated.'),
    notification.createdAt && (React.createElement("div", { style: { marginTop: '0.5rem', color: '#9ca3af', fontSize: 12 } }, formatDate(notification.createdAt, 'dd MMM yyyy, hh:mm a')))));
const getLoginNotificationPopupKey = () => {
    const tokenValue = sessionStorage.getItem('token') || '';
    const clientId = sessionStorage.getItem('client_id') || '';
    const companyId = sessionStorage.getItem('company_id') || '';
    return `notification_login_popup_shown_${clientId}_${companyId}_${tokenValue}`;
};
const NotificationBell = () => {
    var _a;
    const navigate = useNavigate();
    const { showNotification } = useNotificationPopup();
    const overlayRef = useRef(null);
    const bellButtonRef = useRef(null);
    const socketRef = useRef(null);
    const registrationIntervalRef = useRef(null);
    const isNotificationRegisteredRef = useRef(false);
    const [activeTab, setActiveTab] = useState('unread');
    const authState = useSelector((state) => state.auth);
    const { data: notifications = { unread: [], read: [], unreadCount: 0, readCount: 0 }, isFetching, refetch: refetchNotifications } = useGetNotificationsQuery({ page: 1, size: 8 }, {
        refetchOnFocus: true,
        refetchOnMountOrArgChange: true,
    });
    const refetchNotificationsRef = useRef(refetchNotifications);
    const previousUnreadCountRef = useRef(null);
    const pendingSocketPopupCountRef = useRef(0);
    const [markNotificationRead] = useMarkNotificationReadMutation();
    const unreadCount = (_a = notifications.unreadCount) !== null && _a !== void 0 ? _a : notifications.unread.length;
    const totalNotifications = notifications.unread.length + notifications.read.length;
    const activeNotifications = activeTab === 'unread' ? notifications.unread : notifications.read;
    const groupedNotifications = groupNotificationsByCategory(activeNotifications);
    refetchNotificationsRef.current = refetchNotifications;
    const openNotificationPanel = () => {
        var _a, _b;
        if (!bellButtonRef.current) {
            return;
        }
        (_b = (_a = overlayRef.current) === null || _a === void 0 ? void 0 : _a.toggle) === null || _b === void 0 ? void 0 : _b.call(_a, {
            currentTarget: bellButtonRef.current,
            target: bellButtonRef.current,
        });
    };
    useEffect(() => {
        if (activeTab === 'unread' && notifications.unread.length === 0 && notifications.read.length > 0) {
            setActiveTab('read');
        }
        if (activeTab === 'read' && notifications.read.length === 0 && notifications.unread.length > 0) {
            setActiveTab('unread');
        }
    }, [activeTab, notifications.read.length, notifications.unread.length]);
    useEffect(() => {
        if (isFetching || unreadCount <= 0) {
            return;
        }
        const popupShownKey = getLoginNotificationPopupKey();
        if (sessionStorage.getItem(popupShownKey) === 'true') {
            return;
        }
        sessionStorage.setItem(popupShownKey, 'true');
        showNotification({
            type: 'info',
            title: 'Notifications',
            message: `${unreadCount} new notifications received.`,
            viewLabel: 'View',
            onView: openNotificationPanel,
        });
    }, [isFetching, showNotification, unreadCount]);
    useEffect(() => {
        if (isFetching) {
            return;
        }
        if (previousUnreadCountRef.current === null) {
            previousUnreadCountRef.current = unreadCount;
            return;
        }
        if (unreadCount > previousUnreadCountRef.current) {
            const delta = unreadCount - previousUnreadCountRef.current;
            const suppressedCount = Math.min(delta, pendingSocketPopupCountRef.current);
            const popupCount = delta - suppressedCount;
            pendingSocketPopupCountRef.current = Math.max(0, pendingSocketPopupCountRef.current - delta);
            if (popupCount > 0) {
                showNotification({
                    type: 'info',
                    title: 'Notifications',
                    message: `${popupCount} new notification received.`,
                    viewLabel: 'View',
                    onView: openNotificationPanel,
                });
            }
        }
        else if (unreadCount < previousUnreadCountRef.current) {
            pendingSocketPopupCountRef.current = 0;
        }
        previousUnreadCountRef.current = unreadCount;
    }, [isFetching, showNotification, unreadCount]);
    useEffect(() => {
        const tokenValue = authState === null || authState === void 0 ? void 0 : authState.token;
        const clientId = authState === null || authState === void 0 ? void 0 : authState.client_id;
        const companyId = authState === null || authState === void 0 ? void 0 : authState.company_id;
        if (!tokenValue || !clientId || !companyId || socketRef.current) {
            return undefined;
        }
        let accessToken = tokenValue;
        if (typeof tokenValue === 'string') {
            try {
                const parsedToken = JSON.parse(tokenValue);
                accessToken = (parsedToken === null || parsedToken === void 0 ? void 0 : parsedToken.access) || tokenValue;
            }
            catch (_error) {
                accessToken = tokenValue;
            }
        }
        else if (typeof tokenValue === 'object') {
            accessToken = (tokenValue === null || tokenValue === void 0 ? void 0 : tokenValue.access) || '';
        }
        const encodedAccount = window.btoa(`${clientId}|${companyId}`);
        const socket = io(`${getSocketUrl()}/notification`, {
            auth: {
                token: accessToken,
                x_account: encodedAccount,
            },
            query: {
                token: accessToken,
                x_account: encodedAccount,
            },
            path: '/socket.io',
            transports: ['polling', 'websocket'],
            autoConnect: false,
            reconnection: true,
        });
        const refreshNotifications = () => {
            console.log('[notification] refetch notifications');
            void refetchNotificationsRef.current();
        };
        const registerNotificationSocket = () => {
            console.log('[notification] register_notification emit', {
                clientId,
                companyId,
            });
            socket.emit('register_notification', {
                token: accessToken,
                x_account: encodedAccount,
            });
        };
        const clearRegistrationInterval = () => {
            if (registrationIntervalRef.current) {
                clearInterval(registrationIntervalRef.current);
                registrationIntervalRef.current = null;
            }
        };
        const ensureNotificationRegistration = () => {
            clearRegistrationInterval();
            isNotificationRegisteredRef.current = false;
            registerNotificationSocket();
            registrationIntervalRef.current = setInterval(() => {
                if (isNotificationRegisteredRef.current) {
                    clearRegistrationInterval();
                    return;
                }
                registerNotificationSocket();
            }, 2000);
        };
        const handleNewNotification = (payload) => {
            console.log('[notification] notification:new received', payload);
            if (!isMatchingSocketAccount(payload, clientId, companyId)) {
                console.log('[notification] notification:new ignored due to account mismatch', {
                    activeClientId: clientId,
                    activeCompanyId: companyId,
                    payload,
                });
                return;
            }
            pendingSocketPopupCountRef.current += 1;
            showNotification({
                type: 'info',
                title: (payload === null || payload === void 0 ? void 0 : payload.title) || 'Notifications',
                message: '1 new notification received.',
                viewLabel: 'View',
                onView: openNotificationPanel,
            });
            refreshNotifications();
        };
        const handleNotificationUpdated = (payload) => {
            console.log('[notification] notification:updated received', payload);
            if (!isMatchingSocketAccount(payload, clientId, companyId)) {
                console.log('[notification] notification:updated ignored due to account mismatch', {
                    activeClientId: clientId,
                    activeCompanyId: companyId,
                    payload,
                });
                return;
            }
            refreshNotifications();
        };
        socket.on('connect', () => {
            console.log('[notification] socket connected', socket.id);
            ensureNotificationRegistration();
        });
        socket.on('disconnect', () => {
            console.log('[notification] socket disconnected');
            isNotificationRegisteredRef.current = false;
            clearRegistrationInterval();
        });
        socket.on('notification:registered', (payload) => {
            console.log('[notification] notification:registered', payload);
            isNotificationRegisteredRef.current = true;
            clearRegistrationInterval();
        });
        socket.on('notification:error', (payload) => {
            console.log('[notification] notification:error', payload);
            isNotificationRegisteredRef.current = false;
        });
        socket.on('notification:new', handleNewNotification);
        socket.on('notification:updated', handleNotificationUpdated);
        socket.connect();
        socketRef.current = socket;
        return () => {
            clearRegistrationInterval();
            socket.off('notification:registered');
            socket.off('notification:error');
            socket.off('disconnect');
            socket.off('notification:new', handleNewNotification);
            socket.off('notification:updated', handleNotificationUpdated);
            socket.disconnect();
            socketRef.current = null;
        };
    }, [authState, showNotification]);
    const handleToggle = (event) => __awaiter(void 0, void 0, void 0, function* () {
        var _b;
        yield refetchNotifications();
        (_b = overlayRef.current) === null || _b === void 0 ? void 0 : _b.toggle(event);
    });
    const handleClick = (notification) => __awaiter(void 0, void 0, void 0, function* () {
        var _c;
        if (!notification.read) {
            try {
                yield markNotificationRead({ id: notification.id }).unwrap();
            }
            catch (error) {
                console.error('Failed to mark notification as read', error);
            }
        }
        (_c = overlayRef.current) === null || _c === void 0 ? void 0 : _c.hide();
        navigate(getNotificationRoute(notification));
    });
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { style: { position: 'relative', marginRight: '0.75rem' } },
            React.createElement("button", { ref: bellButtonRef, type: "button", "aria-label": "Notifications", onClick: handleToggle, style: {
                    display: 'inline-flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    width: 40,
                    height: 40,
                    border: 'none',
                    borderRadius: '50%',
                    background: 'transparent',
                    color: '#ffffff',
                    cursor: 'pointer',
                } },
                React.createElement("i", { className: "pi pi-bell", style: { fontSize: 18, color: '#ffffff' } })),
            unreadCount > 0 && (React.createElement("span", { style: {
                    position: 'absolute',
                    top: 0,
                    right: 0,
                    minWidth: 18,
                    height: 18,
                    borderRadius: 9,
                    background: '#ef4444',
                    color: '#fff',
                    fontSize: 11,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    padding: '0 4px',
                    fontWeight: 700,
                } }, unreadCount > 99 ? '99+' : unreadCount))),
        React.createElement(OverlayPanel, { ref: overlayRef, dismissable: true, className: "notification-overlay-panel", style: { width: '24rem' } },
            React.createElement("div", { style: { display: 'flex', flexDirection: 'column', gap: '0.75rem' } },
                React.createElement("div", { style: {
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'space-between',
                        gap: '0.75rem',
                    } },
                    React.createElement("div", { style: { fontWeight: 600, fontSize: 16 } }, "Notifications"),
                    React.createElement("button", { type: "button", "aria-label": "Close notifications", onClick: () => { var _a; return (_a = overlayRef.current) === null || _a === void 0 ? void 0 : _a.hide(); }, style: {
                            width: 28,
                            height: 28,
                            border: 'none',
                            borderRadius: '50%',
                            background: 'transparent',
                            color: '#6b7280',
                            cursor: 'pointer',
                            display: 'inline-flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            fontSize: 16,
                            fontWeight: 700,
                            lineHeight: 1,
                        } }, "X")),
                React.createElement("div", { style: {
                        display: 'flex',
                        flexDirection: 'column',
                        borderBottom: '1px solid #e5e7eb',
                        paddingBottom: '0.75rem',
                    } },
                    React.createElement("div", { style: { display: 'flex', gap: '0.5rem' } },
                        React.createElement("button", { type: "button", onClick: () => setActiveTab('unread'), style: {
                                border: 'none',
                                borderBottom: activeTab === 'unread' ? '2px solid #2563eb' : '2px solid transparent',
                                background: 'transparent',
                                color: activeTab === 'unread' ? '#2563eb' : '#6b7280',
                                fontWeight: 600,
                                fontSize: 13,
                                padding: '0.5rem 0.75rem',
                                cursor: 'pointer',
                                flex: 1,
                                display: 'flex',
                                flexDirection: 'column',
                                alignItems: 'center',
                                justifyContent: 'center',
                                lineHeight: 1.2,
                            } },
                            React.createElement("span", null, "New")),
                        React.createElement("button", { type: "button", onClick: () => setActiveTab('read'), style: {
                                border: 'none',
                                borderBottom: activeTab === 'read' ? '2px solid #2563eb' : '2px solid transparent',
                                background: 'transparent',
                                color: activeTab === 'read' ? '#2563eb' : '#6b7280',
                                fontWeight: 600,
                                fontSize: 13,
                                padding: '0.5rem 0.75rem',
                                cursor: 'pointer',
                                flex: 1,
                                display: 'flex',
                                flexDirection: 'column',
                                alignItems: 'center',
                                justifyContent: 'center',
                                lineHeight: 1.2,
                            } },
                            React.createElement("span", null, "Seen")))),
                isFetching && totalNotifications === 0 && (React.createElement("div", { style: { color: '#6b7280' } }, "Loading notifications...")),
                !isFetching && totalNotifications === 0 && (React.createElement("div", { style: { color: '#6b7280' } }, "No notifications available.")),
                !isFetching && totalNotifications > 0 && activeNotifications.length === 0 && (React.createElement("div", { style: { color: '#6b7280' } },
                    "No ",
                    activeTab,
                    " notifications available.")),
                activeNotifications.length > 0 && (React.createElement("div", { style: {
                        display: 'flex',
                        flexDirection: 'column',
                        gap: '0.75rem',
                        maxHeight: '26rem',
                        overflowY: 'auto',
                        paddingRight: '0.25rem',
                    } }, Object.entries(groupedNotifications).map(([category, items]) => (React.createElement("div", { key: category, style: { display: 'flex', flexDirection: 'column', gap: '0.75rem' } },
                    React.createElement("div", { style: { fontWeight: 600, fontSize: 14, color: '#1f2937' } }, category),
                    items.map((notification) => renderNotificationItem(notification, handleClick)))))))))));
};
export default NotificationBell;
